import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { formatMessage } from '../../../lib/intl';
import { format } from '../../../lib/money';

const i18n = defineMessages({
  withSlots: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} {slotsName}`,
  },
  withSlots_adult: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_adult',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} adults`,
  },
  withSlots_passenger: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_passenger',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} passengers`,
  },
  withSlots_ticket: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_ticket',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} tickets`,
  },
  withSlots_seat: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_seat',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} seats`,
  },
  withSlots_item: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_item',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} items`,
  },
  withSlots_shirt: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_shirt',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} shirts`,
  },
  withSlots_person: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_person',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} people`,
  },
  withSlots_guest: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_guest',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} guests`,
  },
  withSlots_player: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_player',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} players`,
  },
  withSlots_student: {
    id: 'autoPilot.triggerAmount.makePurchaseWhen.withSlots_student',
    defaultMessage: `Make purchase when the group reaches {amount}
      with at least {minSlots} students`,
  },
});

const TriggerFieldsSPP = ({ amount, minSlots, purchase, intl }) => {
  if (minSlots > 1) {
    return (
      <span className="h3">
        {formatMessage(intl)(i18n.withSlots, {
          amount: `${format(amount)} ${amount.currencyCode}`,
          minSlots,
        }, purchase.slotName)}
      </span>
    )
  }

  return (
    <span className="h3">
      <FormattedMessage
        id="autoPilot.triggerAmount.makePurchaseWhen"
        defaultMessage="Make purchase when group reaches {amount}"
        values={{
          amount: <span className="pr-1 pl-1">{format(amount)} {amount.currencyCode}</span>
        }}
      />

    </span>
  );
};

export default injectIntl(TriggerFieldsSPP);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/trigger-fields.spp.js